export const ViewType = {
  ADD: 1,
  EDIT: 2,
  VIEW: 3,
};
